// @flow

import React, {useContext} from 'react';
import {Group, Item} from '@pb/kit-component-group';
import {PaginationStripe} from '@pb/kit-component-pagination';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import {ScrollContext} from './contexts/data-table-scroll-context';
import './data-table.styl';
import styles from './data-table-scroll.module.styl';

import type {Element, StatelessFunctionalComponent} from 'react';


const hashedClassNames = hashedClasses(styles);

type Props = {
    stripe?: Element<typeof PaginationStripe>,
};

export const DataTableDefaultNavigation: StatelessFunctionalComponent<Props> = (props: Props) => {
    const {
        stripe
    } = props;

    const {
        scrollXLineRef,
    } = useContext(ScrollContext);

    const scrollLine = (
        <div
            className={hashedClassNames['scroll-line-container']}
            ref={scrollXLineRef}
        />
    );

    if (!stripe) {
        return scrollLine;
    }

    return (
        <Group justify="space-between" alignItems="center">
            {stripe}
            <Item className={hashedClassNames['scroll-line-wrapper']}>
                {scrollLine}
            </Item>
        </Group>
    );
};
